import { RoleName } from '../user';
import { GuardRoleAffiliation } from './guardRoleAffiliation';

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GuardClassicCarsDataManager extends GuardRoleAffiliation {
    protected getRoles(): RoleName[] {
        return [RoleName.ClassicCars];
    }
}
